export default "__VITE_ASSET__zeXOdP1O__"